import type {
  DiagnosisConfig,
  DiagnosisSession,
  IssueDefinition,
  OutcomeDefinition,
  SummaryKey,
} from './types';

const summaryLabels: Record<SummaryKey, string> = {
  account: '目标账号',
  existingMembership: '已有会员',
  geminiAccess: 'Gemini 网页',
  detectedRegion: '系统识别地区',
  accountCountry: '账号关联地区',
  paymentProfile: '付款资料',
  pageMessage: '页面提示',
  thirdParty: '具体服务',
};

export function buildDiagnosisCode(issue: IssueDefinition, outcome: OutcomeDefinition): string {
  return `${issue.code}-${outcome.code}`;
}

export function buildSummary(
  config: DiagnosisConfig,
  session: DiagnosisSession,
): string {
  const issue = config.issues.find((candidate) => candidate.id === session.issueId);
  const outcome = session.outcomeId ? config.outcomes[session.outcomeId] : undefined;
  if (!issue || !outcome) {
    throw new Error('Cannot build summary before diagnosis is complete');
  }

  const latestAnswers = new Map<SummaryKey, string>();
  for (const answer of session.answers) {
    if (answer.summaryKey) {
      latestAnswers.set(answer.summaryKey, answer.label);
    }
  }

  const details = Array.from(latestAnswers.entries()).map(
    ([key, value]) => `${summaryLabels[key]}：${value}`,
  );

  return [
    `诊断编号：${buildDiagnosisCode(issue, outcome)}`,
    `问题：${issue.title}`,
    ...details,
    `结果：${outcome.title}`,
    `建议：${outcome.recommendation}`,
  ].join('\n');
}
